import { create } from 'zustand';
import { adminRoleManagementApi } from '@api/api-config.ts';
import { AdminRoleResponse } from '@api/generated/portal-be-admin';

interface AdminRoleStoreState {
  loading: boolean;
  error: string | null;

  data: AdminRoleResponse[] | null;

  pagination: {
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
  };

  loadRoles: () => void;
}

export const useCreateAdminRoleStore = create<AdminRoleStoreState>((set, get) => ({
  loading: false,
  error: null,

  pagination: {
    page: 0,
    size: 20,
    totalElements: 0,
    totalPages: 0,
  },

  data: null,

  loadRoles: async () => {
    try {
      set({ loading: true, error: null });
      const { pagination } = get();

      const response = await adminRoleManagementApi.getRoles({ page: pagination.page, size: pagination.size });
      set({
        loading: false,
        error: null,
        pagination: {
          page: response.data.page,
          size: response.data.size,
          totalElements: response.data.total || 0,
          totalPages: response.data.totalPages || 0,
        },
        data: response.data.items,
      });
    } catch (error) {
      set({ loading: false, error: error instanceof Error ? error.message : 'Chyba při načítání' });
    }
  },
}));
